// Whether the update-terms editor's start-date lock applies to the line currently
// in the panel. A lock only holds a value in place, so it applies only where the
// field has one: an existing line's own date, or the amendment's effective date
// seeding a new line. Locking an empty required field leaves it nobody can fill.
interface StartDateLockArgs {
  isLockRequested: boolean;
  isEditingExistingLine: boolean;
  existingLineStartDate: string | null | undefined;
  seededStartDate: string | undefined;
}

export const isStartDateLocked = ({
  isLockRequested,
  isEditingExistingLine,
  existingLineStartDate,
  seededStartDate
}: StartDateLockArgs): boolean => {
  if (!isLockRequested) return false;
  return isEditingExistingLine ? !!existingLineStartDate : !!seededStartDate;
};

// A pricing that fixes the billing frequency also fixes the billing start date, but
// only where something fills it: an existing line's own date, or, on a new line, the
// amendment's seeded date or a service start date field the billing date follows.
interface BillingStartDateLockedByFrequencyArgs {
  isBillingFrequencyLocked: boolean;
  isEditingExistingLine: boolean;
  existingLineBillingStartDate: string | null | undefined;
  seededStartDate: string | undefined;
  isServiceStartDateVisible: boolean;
}

export const isBillingStartDateLockedByFrequency = ({
  isBillingFrequencyLocked,
  isEditingExistingLine,
  existingLineBillingStartDate,
  seededStartDate,
  isServiceStartDateVisible
}: BillingStartDateLockedByFrequencyArgs): boolean => {
  if (!isBillingFrequencyLocked) return false;
  return isEditingExistingLine
    ? !!existingLineBillingStartDate
    : !!seededStartDate || isServiceStartDateVisible;
};
